export default __webpack_public_path__ + "static/media/perfil-proveedor.1040a3f2.svg";